import { axiosInstance } from './apiCommon';

/** Key for DynamicForms in Portal (epdweb): pages list, editor, PDF. */
export const FeatureFlagKeyDynamicFormsPortal = 'dynamic-forms.portal';

/** Key for public site (wwwenvirondec): viewing published dynamic form EPDs. */
export const FeatureFlagKeyDynamicFormsPublicSite = 'dynamic-forms.public-site';

export const getFeatureFlags = () =>
  axiosInstance.get<Record<string, boolean>>('/api/v1/feature-flags').then((r) => r.data);
